import { apiService } from '../api/api-client';
import type { BulkReRateRequest, BulkReRateResponse } from '@/types';

/** POST /positions/bulk_re_rate/ — atomic bulk re-rate (LR-539). All-or-nothing:
 *  any invalid row → 400 with a per-row failed[] and zero writes. */
export const bulkReRateService = {
  async bulkReRate(request: BulkReRateRequest): Promise<BulkReRateResponse> {
    return apiService.post<BulkReRateResponse>('/positions/bulk_re_rate/', request);
  },
};
